import React from 'react';
import { useProductionSites } from '../../production-site/production-sites-api';
import { FormPanel, FormAutocomplete } from '@eas/common-web';
import { HelpLabel } from '../../../components/help/help-label';

export function StepOriginalProductionSiteContent() {
  const productionSites = useProductionSites();
  return (
    <FormPanel label="Vyplňte">
      <FormAutocomplete
        name="originalProductionSite"
        label={
          <HelpLabel
            label="Průmyslové místo"
            code="PRODUCTION_SITE_SPLIT_ORIGINAL_PRODUCTION_SITE"
          />
        } // Průmyslové místo, které bude rozděleno
        source={productionSites}
      />
    </FormPanel>
  );
}
